"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const joi_1 = __importDefault(require("joi"));
const IInvoice_1 = require("../models/invoice/IInvoice");
const GenericValidator_1 = __importDefault(require("./GenericValidator"));
class InvoiceFilterValidator extends GenericValidator_1.default {
    invoiceStatus = Object.values(IInvoice_1.IInvoiceStatus);
    _creationDateAndAmountSchema = joi_1.default.object({
        from: joi_1.default.number().optional(),
        to: joi_1.default.number().optional(),
    });
    _invoiceFilterSchema = joi_1.default.object({
        customerId: joi_1.default.string().optional(),
        customerName: joi_1.default.string().optional(),
        poNumber: joi_1.default.string().optional(),
        trailerNumber: joi_1.default.string().optional(),
        bolNumber: joi_1.default.string().optional(),
        transactionId: joi_1.default.number().optional(),
        invoiceNumber: joi_1.default.string().optional(),
        trackingNumber: joi_1.default.string().optional(),
        creationDate: this._creationDateAndAmountSchema.optional(),
        amount: this._creationDateAndAmountSchema.optional(),
        status: joi_1.default.array()
            .items(joi_1.default.string().valid(...this.invoiceStatus))
            .optional(),
    });
    validate(input) {
        super.validate(input, 'IInvoiceFilter', this._invoiceFilterSchema);
    }
}
exports.default = InvoiceFilterValidator;
